import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconTrashPaper: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="trash-paper"><path d="M7.375 10.9722L6.34722 11.4861L5 10.1389M15.5972 13.5417L17.7624 13.1086M9.94444 17.6528L10.9722 18.6806L13.0278 21.25L16.1111 20.2222L20.2222 16.625L18.1667 13.0278L21.25 8.91667L17.1389 6.86111V4.80556L14.0556 2.75L10.9722 4.80556L4.29167 5.83333L4.80556 9.94444L2.75 10.9722V14.0556L4.29167 15.0833L4.80556 19.1944L7.375 20.7361L10.5 18.9504M13.0278 7.375L11.2128 5.10624" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconTrashPaper;
